export default __webpack_public_path__ + "static/media/earth.6fb71532.svg";